export default __webpack_public_path__ + "static/media/AvenirNextW04-Regular.84001e00.ttf";